export const CHARGE_MONTHLY_SHOW_TABS = ['general', 'daily'] as const;

export type ChargeMonthlyShowTab = (typeof CHARGE_MONTHLY_SHOW_TABS)[number];

export const CHARGE_MONTHLY_DEFAULT_TAB: ChargeMonthlyShowTab = 'general';
